import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'reeds',
      d: 'M0,-4.5h1.5v0.5h-1.5zM-1.5,-4h0.5v1.5h-0.5zM0,-4h2v0.5h-2zM0,-3.5h1.5v0.5h-1.5zM2,-3.5h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM0,-3h2.5v1h-2.5zM-2.5,-2.5h1.5v1h-1.5zM0,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM-2,-1.5h1v1h-1zM0,-1.5h2v0.5h-2zM0,-1h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5zM-1.5,-0.5h1v0.5h-1zM0,-0.5h1.5v0.5h-1.5zM-1.5,0h2.5v0.5h-2.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-3.5h1v3h-1zM1,-2h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM-0.5,-0.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M0,-6.5h1v2h-1zM-2,-5.5h1v1.5h-1z' },
  ],
  pixels: 83,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
